import {ColumnCode, ColumnType} from 'priority-web-sdk/enums';
import {getLang, getLocale} from './index';

export function getDateFormat(type, code) {
    let format;
    if (type === ColumnType.Date || type === ColumnType.Time) {
        const lang = getLang();
        if (type === ColumnType.Time) {
            format = lang === '3' ? 'hh:mm a' : 'HH:mm';
        } else {
            switch (code) {
                case ColumnCode.Date8:
                    format = lang === '3' ? 'MM/DD/YY' : 'DD/MM/YY';
                    break;
                case ColumnCode.Date10:
                    format = lang === '3' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
                    break;
                case ColumnCode.Date14:
                    format = lang === '3' ? 'MM/DD/YY hh:mm a' : 'DD/MM/YY HH:mm';
                    break;
            }
        }
    }
    return format;
}

export function getDefaultDateTimeFormat() {
    return getLang() === '3' ? 'MM/DD/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm';
}

export function getDefaultDateFormat() {
    return getLang() === '3' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
}

export const getIntlDateTimeFormat = (dateString: string) => {
    const date = new Date(dateString);
    const locale = getLocale();
    const upgradeDate = new Intl.DateTimeFormat(locale).format(date);
    return upgradeDate;
};

export const getGMTdiff = () => {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
        timeZone: 'Asia/Jerusalem',
        timeZoneName: 'short'
    };
    const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(now);
    const tzName = parts.find(p => p.type === 'timeZoneName').value; // "GMT+2" or "GMT+3"
    return Number(tzName[4]);
};

export const getGMTtime = (israelTimeString: string, gmtDiff: number) => {
    const delimiter = ':';
    const [hrs, min] = israelTimeString.split(delimiter);
    // Convert Israel local time to GMT
    let gmtHour = Number(hrs) - gmtDiff;
    // Wrap around if negative
    if (gmtHour < 0) {
        gmtHour += 24; // default, GMT/UTC times are shown in 24-hour clock
    }
    const res = String(gmtHour).padStart(2, '0') + delimiter + min;
    return res;
};
